import { html } from "lit";
import { formatHtml } from "@trumpf/ux.common-storybook";
import { addI18nTranslations } from "../../utils";

export default {
    title: "Components/Stateful Filter & Content/Stateful Content/Stateful Overview",
    parameters: {
        docs: {
            source: {
                transform: formatHtml,
            },
        },
    },
    component: "ux-iws-stateful-overview",
    args: {
        countResultLabel: "",
        debug: "true",
        maxFixedColWidth: "add default manually",
        scope: "stateful-overview",
        showCount: "true",
        url: "generated-mock-data/mysoftware.json",
        showSwitch: "true",
        env: "QA",
    },
    argTypes: {
        countResultLabel: {
            control: "text",
        },
        debug: {
            control: "boolean",
        },
        maxFixedColWidth: {
            control: "number",
        },
        scope: {
            control: "text",
        },
        showCount: {
            control: "boolean",
        },
        url: {
            control: "text",
        },
        showSwitch: {
            control: "boolean",
        },
    },
};

const Template = ({
    countResultLabel,
    debug,
    maxFixedColWidth,
    scope,
    showCount,
    url,
    showSwitch,
}) => {
    addI18nTranslations({
        namespace: "my-software",
        language: "de-DE",
        translations: {
            content: {
                isFav: {
                    column: "Fav",
                },
                name: {
                    column: "Produktname",
                },
                latestAvailableVersion: {
                    column: "Neueste verfügbare Version",
                    update: "Update",
                },
                serviceAgreementStatus: {
                    column: "Servicevereinbarung",
                    values: {
                        SERVICE_AGREEMENT_Inactive:
                            "keine aktive Servicevereinbarung",
                        SERVICE_AGREEMENT_Active: "Aktiv",
                    },
                },
                detailLink: {
                    column: "Details",
                },
            },
        },
    });

    return html`<ux-iws-stateful-overview
        count-result-label="${countResultLabel}"
        debug="${debug}"
        max-fixed-col-width="${maxFixedColWidth}"
        scope="${scope}"
        show-count="${showCount}"
        url="${url}"
        switch="${showSwitch}"
    ></ux-iws-stateful-overview>`;
};

export const Default = Template.bind({});
Default.args = {
    countResultLabel: "",
    debug: "true",
    maxFixedColWidth: "add default manually",
    scope: "stateful-overview",
    showCount: "true",
    url: "generated-mock-data/mysoftware.json",
    showSwitch: "true",
};
